import { Reducer } from 'redux'
import { GetUsersTypes, UsersState } from './types'

const INITIAL_STATE: UsersState = {
  data: [],
  loading: false,
  error: false,
  errorStack: undefined
}

const reducer: Reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetUsersTypes.GET_USERS_REQUEST:
      return { ...state, loading: true, error: false, errorStack: undefined }
    case GetUsersTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
        errorStack: undefined
      }
    case GetUsersTypes.GET_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorStack: action.payload.errorStack
      }
    default:
      return state
  }
}

export default reducer
